import React from 'react';
import { motion } from 'framer-motion';
import { Ticket, Headset, BookOpen, ArrowLeft } from 'lucide-react';

interface TicketEscalationProps {
  onActionSelect: (action: string) => void;
}

const TicketEscalation: React.FC<TicketEscalationProps> = ({ onActionSelect }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm w-full max-w-[85%] mt-2 mb-2"
    >
      <p className="text-sm text-gray-800 mb-3 font-medium">
        I couldn't confidently answer that. How would you like to proceed?
      </p>
      <div className="flex flex-col gap-2">
        <button
          onClick={() => onActionSelect('Raise Ticket')}
          className="flex items-center gap-3 px-3 py-2 text-sm text-gray-700 bg-gray-50 border border-gray-200 rounded-lg hover:bg-blue-50 hover:border-blue-300 hover:text-blue-700 transition-colors"
        >
          <Ticket className="w-4 h-4" />
          <span>Raise Ticket</span>
        </button>
        <button
          onClick={() => onActionSelect('Chat with Agent')}
          className="flex items-center gap-3 px-3 py-2 text-sm text-gray-700 bg-gray-50 border border-gray-200 rounded-lg hover:bg-blue-50 hover:border-blue-300 hover:text-blue-700 transition-colors"
        >
          <Headset className="w-4 h-4" />
          <span>Chat with Agent</span>
        </button>
        <button
          onClick={() => onActionSelect('Browse FAQ')}
          className="flex items-center gap-3 px-3 py-2 text-sm text-gray-700 bg-gray-50 border border-gray-200 rounded-lg hover:bg-blue-50 hover:border-blue-300 hover:text-blue-700 transition-colors"
        >
          <BookOpen className="w-4 h-4" />
          <span>Browse FAQ</span>
        </button>
        <button
          onClick={() => onActionSelect('Return to Main Menu')}
          className="flex items-center gap-3 px-3 py-2 text-sm text-blue-700 bg-blue-50/70 border border-blue-200 rounded-lg hover:bg-blue-100 hover:border-blue-300 transition-colors"
        >
          <ArrowLeft className="w-4 h-4 text-blue-600" />
          <span>Return to Main Menu</span>
        </button>
      </div>
    </motion.div>
  );
};

export default TicketEscalation;
